import isSignatory from './is-signatory';
import isInfluencer from './is-influencer';
import isOrganizer from './is-organizer';

const hasAnyUpdatePermission = (participant) => (
  isSignatory(participant) || isInfluencer(participant) || isOrganizer(participant)
);

export default hasAnyUpdatePermission;
